import { inject, Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { environment } from "../../../environments/environment";
import { HttpService } from "../../shared/services/http.service";


@Injectable({providedIn: 'root'})
export class ThemeService {
    private themeList = `${environment.opbBackendHost}/api/admin/theme/list`; 
    private themeUpdate = `${environment.opbBackendHost}/api/admin/theme/update`; 
    private themeAdd = `${environment.opbBackendHost}/api/admin/theme/create`; 
    private themeDelete = `${environment.opbBackendHost}/api/admin/theme/remove`; 
    private themeCopy = `${environment.opbBackendHost}/api/admin/theme/copy`; 

    httpService=inject(HttpService);

    getThemes(data: any): Observable<any> {
        return this.httpService.post(this.themeList,data);
    }

    addTheme(data: any): Observable<any> {
        return this.httpService.post(this.themeAdd,data);
    }

    updateTheme(data: any): Observable<any> {
        return this.httpService.post(this.themeUpdate,data);
    }

    deleteTheme(data: any): Observable<any> {
        return this.httpService.post(this.themeDelete,data);
    }

    copyTheme(data: any): Observable<any> {
        return this.httpService.post(this.themeCopy,data);
    }

}